import { reactive } from "vue";

export default reactive({
    title: "",
    message: "",
    url: "",
    status: 0
});